<template>
  <Form 
    :d_form='form'
    :d_se_pemungutan='se_pemungutan'
    :d_negeri='negeri'
    :d_status='status'
    v-if="id > 0 && load == 4"
  /> 
  <Form 
    :d_form='form'
    :d_se_pemungutan='se_pemungutan'
    :d_negeri='negeri'
    :d_status='status'
    v-else-if="id == 0 && load == 3"
  /> 
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import Form from "./_From.vue";

export default {
  extends: ZResource,
  components: {
    Form
  },
  props: {
    id: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'se.pemungutan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Semen Beku', route: '/se' },
        { label: 'Pemungutan Semen Ternakan', route: '/se/pemungutan' },
      ],
      title : 'Tambah Baka Jantan',
      form : {
        id : 0,
        tarikh : 0,
        se_katalog_id : '',
        se_pemungutan_id: '',
        motiliti: '',
        stor_keaktifan : '',
        kepekatan_sperma : '',
        no_ejekulasi : '',
        lkp_ejakulasi_id : '',
        lkp_ejakulasi_label : '',
        kepekatan_straw : '',
        jumlah_extender_a : '',
        isipadu : '',
        jumlah_extender_b : '',
        motiliti_sejuk : '',
        motiliti_beku: '',
        jumlah_straw:'',
        catatan : '',
        user_id : '',
        nama: '',
        lkp_status_id:'',
        hantar:2
      },
      form1:[],
      se_pemungutan : [],
      negeri: [],
      load : 0
      
      
    }
  },
  methods: {
    
    getKatalog(){
      this.$zcomm.get(this.api_service + 'lookup/se_pemungutan', {}).then(res => {
        this.se_pemungutan = res
        this.load = this.load + 1
      })
    },

    getNegeri(){
      this.$zcomm.get(this.api_service + 'lookup/negeri/1', {}).then(res => {
         this.negeri = res
         this.load = this.load + 1
      })
    },
    getStatus(){
      this.$zcomm.get(this.api_service + 'lookup/status_mp', {}).then(res => {
         this.status = res
         this.load = this.load + 1
      })
    },
 
    getData(){
      if(this.id > 0){
        this.$zcomm.get(this.api_service + 'se_pengeluaran/show/'+this.id, {}).then(res => {
          this.form = res
          this.load = this.load + 1

        })
      }
    },
  
  },

  watch: {

  },
  mounted() {
    this.getData();
    this.getStatus()
    this.getNegeri()
    this.getKatalog()
    
  }
    
}
</script>
